import React from 'react';
import PropTypes from 'prop-types';
import * as S from '../../AnswerSheet.styles';
import { getAlternativeByCondition } from './QuestionTypes.base';

const MultipleChoiceWithPicture = ({ alternatives }) => (
  <>
    {alternatives?.map((alternative, index) => (
      <S.AlternativeContainerImage
        key={alternative.alternative_id}
        correct={alternative.right && alternative.chosen_by_user}
        wrongChosen={!alternative.right && alternative.chosen_by_user}
        rightNotChosen={alternative.right && !alternative.chosen_by_user}
      >
        {getAlternativeByCondition(alternative, index)}
        <S.AlternativeImage
          src={alternative?.alternative_image}
          alt={alternative?.alternative_description}
        />
      </S.AlternativeContainerImage>
    ))}
  </>
);

MultipleChoiceWithPicture.propTypes = {
  alternatives: PropTypes.array,
};

export default MultipleChoiceWithPicture;
